module.exports = __webpack_public_path__ + "img/open-windows.50407424.png";